import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { supabase } from '../contexts/AuthContext';

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // With detectSessionInUrl: true, Supabase auto-exchanges the code on init.
    // Do NOT call exchangeCodeForSession - it causes "both auth code and code verifier
    // should be non-empty" (race with auto-exchange consuming the verifier).
    const params = new URLSearchParams(location.search);
    const hashParams = new URLSearchParams(location.hash.replace('#', ''));
    const type = params.get('type') || hashParams.get('type');

    const handleSession = (session: { user: unknown } | null) => {
      if (session) {
        if (type === 'recovery') {
          navigate('/reset-password', { replace: true });
        } else {
          navigate('/dashboard', { replace: true });
        }
      }
    };

    // Listen for auth changes (session set when auto-exchange completes)
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      handleSession(session);
    });

    // Also check current session (in case it was set before we subscribed)
    supabase.auth.getSession().then(({ data: { session } }) => {
      handleSession(session);
    });

    // Fallback: if we still have code after 5s, exchange likely failed
    const timeout = setTimeout(() => {
      const params = new URLSearchParams(window.location.search);
      const hashParams = new URLSearchParams(window.location.hash.replace('#', ''));
      if (params.has('code') || hashParams.has('code')) {
        navigate('/login', {
          replace: true,
          state: { error: 'Sign in timed out. Please try again.' },
        });
      }
    }, 5000);

    return () => {
      subscription.unsubscribe();
      clearTimeout(timeout);
    };
  }, [location.search, location.hash, navigate]);

  return null;
}




